<template>
    <v-timeline>
        <v-timeline-item fill-dot right :color="event.background_color">
            <div :style="{ color: event.color, 'font-weight': 'bold' }">{{event.title}}</div>
            <template #icon>
                <v-btn icon color="white">{{event.time}}</v-btn>
            </template>
        </v-timeline-item>
    </v-timeline>
</template>
<script>
export default {
    name: 'zoezi-teamsport-eventtype-preview',

    props: {
        event: {
            type: Object,
            required: true
        }
    }
}
</script>
